import React from 'react';
import colors from '../../styles/colors';
import { fontBase } from '../../styles/font';
import { transparentize } from '../../styles/mixins';
import { d, getViewPortDimensions } from '../../utils/common';
import GlanceLogo from '../GlanceLogo';
import HeartIcon from '../HeartIcon';
import ThreeDots from '../ThreeDots';
const { vh } = getViewPortDimensions();
const FeedLoading = () => {
    return (React.createElement("div", { style: {
            position: 'absolute',
            backgroundColor: colors.black,
            width: '100%',
            top: 0,
            left: 0,
            height: vh,
            overflow: 'hidden',
            userSelect: 'none',
            touchAction: 'none',
            minHeight: '100vh',
        } },
        React.createElement(GlanceLogo, null),
        React.createElement("div", { style: {
                position: 'absolute',
                top: `calc(${d.glanceTopGap} + ${d.sideGap})`,
                left: 0,
                right: 0,
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    margin: '0 8px',
                    justifyContent: 'stretch',
                } },
                React.createElement("div", { style: {
                        background: transparentize(0.6, colors.white),
                        borderRadius: '4px',
                        height: '2px',
                        position: 'relative',
                        flex: 1,
                        margin: '0 1px',
                    } }),
                React.createElement("div", { style: {
                        background: transparentize(0.6, colors.white),
                        borderRadius: '4px',
                        height: '2px',
                        position: 'relative',
                        flex: 1,
                        margin: '0 1px',
                    } })),
            React.createElement("div", { style: {
                    background: transparentize(0.6, colors.white),
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    marginLeft: '8px',
                    marginTop: '8px',
                } })),
        React.createElement("div", { style: {
                fontSize: `${9 / fontBase}rem`,
                fontWeight: 500,
                lineHeight: '1.22',
                letterSpacing: '0.03px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'absolute',
                bottom: d.glanceBottomGap,
                right: '24px',
                opacity: 0.4,
            } },
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    color: colors.white,
                    textDecoration: 'none',
                    width: '27px',
                    height: '33px',
                    justifyContent: 'flex-end',
                    marginBottom: '5px',
                    paddingBottom: '11px',
                } },
                React.createElement(ThreeDots, null)),
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginBottom: '8px',
                    paddingBottom: '8px',
                    color: colors.white,
                    textDecoration: 'none',
                    width: '27px',
                } },
                React.createElement("i", { style: {
                        background: colors.white,
                        borderRadius: '50%',
                        width: '22px',
                        height: '22px',
                        display: 'block',
                        marginBottom: '4px',
                    } })),
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    paddingBottom: '8px',
                    color: colors.white,
                    textDecoration: 'none',
                    width: '27px',
                    marginBottom: 0,
                } },
                React.createElement(HeartIcon, { liked: false })))));
};
export default FeedLoading;
//# sourceMappingURL=index.js.map